var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs nav-tabs-fillup"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,staticClass:"nav-item",class:{"active": (index == _vm.selectedIndex)},on:{"click":function($event){return _vm.selectTab(index)}}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(tab.title))])])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a852faa","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/SimpleTabs/Tabs.vue
// module id = 1722
// module chunks = 0